import React from 'react';

import { type RouteComponentProps, Route, Switch } from 'react-router';

import LazyComponent from '@fd/ui/LazyComponent';

import { lazyWithRetry } from '../../helpers/utilities';
import ErrorBoundary from '../../layouts/Portal/ErrorBoundary';

const AiMarketing = lazyWithRetry(() => import('./AiMarketing'));
type Props = RouteComponentProps;

const AiMarketingMicroFrontendRoutes: React.FC<Props> = (props: Props) => {
  const {
    match: { path },
  } = props;

  return (
    <ErrorBoundary identifier="ai-marketing-mf">
      <Switch>
        <Route
          path={`${path}`}
          render={() => (
            <LazyComponent>
              <AiMarketing />
            </LazyComponent>
          )}
        />
      </Switch>
    </ErrorBoundary>
  );
};

export default AiMarketingMicroFrontendRoutes;
